<!--招行绑定免密-->
<template>
  <div class="bindMM">
    <div class="content-wrap page-content">
      <header>开通免密自动扣路费</header>
      <p class="header-tip">无需充值&nbsp;&nbsp;无需转账&nbsp;&nbsp;省时更省心</p>
      <div class="image-wrap">
        <img src="../../assets/bindMM/bind-mm-bg.png" alt="">
      </div>
    </div>
    <div class="bottom-wrap">
      <p class="tip">使用ETC上高速，自动扣费需开启免密支付</p>
      <!--<button cool-btn @click="bindMM">查询免密</button>-->
      <button cool-btn @click="bindMM" margin-t-20>开启免密支付</button>
      <!--<button cool-btn @click="bindMM2" margin-t-20>开启免密支付2</button>-->
    </div>
  </div>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
// api
import NewApplyApi from '@/api/newApply.api'
import reconApply from '@/api/reconApply.api'

// store
import { mapState, mapMutations } from 'vuex'
import ETC from '../../config/etc.config'

export default {
  name: 'bindMM',
  mixins: [FunMixin],
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapState(['currentOrder', 'applyOrderInfo'])
  },
  methods: {
    async bindMM() {
      this.m_showLoading()
      try {
        const status = await reconApply.entrustQuery({
          order_sn: this.currentOrder.order_sn,
          payment_mode: 5,
          purchase_party: 6
        })
        if (+status.sign_status === 1) {
          // 1:  已签约，-1:未签约，-2:受理中
          localStorage.setItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD, 'yes')
          await this.pay()
          this.setUserApplyStep(1)
          this.m_backHome()
          return
        }
        const res = await reconApply.entrustSignContract({
          payment_mode: 5,
          purchase_party: 6
        })
        if (res && res.contract) {
          console.log('res.contractres.contractres.contract', res.contract)
          location.href = res.contract.url + '&jsonRequestData=' + res.contract.tmpData
          // this.m_awaitTime(2000)
          // this.getEntrustStatus(4000)
        } else if (res.has_signed) {
          this.m_loadingClose()
          this.m_showToast('您已签约')
          await this.m_awaitTime()
          this.setUserApplyStep(1)
          localStorage.setItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD, 'yes')
          await this.pay()
          this.m_backHome()
        } else if (res.sign_status === -2) {
          await this.getEntrustStatus(1500)
        }
      } catch (e) {
      } finally {
        this.m_loadingClose()
      }
    },
    async getEntrustStatus(time = 3000, times = 3) {
      this.m_showLoading()
      let status
      let i = 0
      while (i < times) {
        status = await NewApplyApi.entrustCheck({
          order_sn: this.currentOrder.order_sn,
          payment_mode: 5,
          purchase_party: 6,
          plate_no: this.currentOrder.plate_no
        })
        status.sign_status = status.sign_status - 0
        // 订单third_type 为 1 表示滴滴平台，不能签车主平台
        if (status.sign_status === 1 || status.sign_status === -5) {
          break
        }
        i++
        if (i < times) await this.m_awaitTime(time)
      }
      this.m_loadingClose()
      if (status.sign_status === 1) {
        // 1:  已签约，-1:未签约，-2:受理中
        this.setUserApplyStep(1)
        localStorage.setItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD, 'yes')
        await this.pay()
        this.m_backHome()
      }
    },
    pay() {
      return reconApply.applyPurchase({
        order_sn: this.currentOrder.order_sn,
        payment_mode: 5,
        purchase_party: 6,
        purchase_type: 8
      })
    },
    ...mapMutations(['setUserApplyStep'])
  },
  created() {
    console.log('created')
  },
  async mounted() {
    console.log('mounted')
    if (localStorage.getItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD) === 'yes') {
      try {
        await this.getEntrustStatus(100, 1)
      } catch (e) {
        console.log('mounted getEntrustStatus', e)
        this.m_loadingClose()
      } finally {
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../style/cool.practical';
.bindMM {
  @include routeViewMinH(210px);
  .content-wrap {
    padding-top: 40px;
  }
  header {
    font-size: 50px;
    font-weight: bold;
    text-align: center;
  }
  .header-tip {
    font-size: 30px;
    color: #666666;
    text-align: center;
    margin-top: 20px;
    line-height: 58px;
  }
  .image-wrap {
    margin-top: 60px;
    text-align: center;
    img {
      margin-left: 60px;
      width: 686px;
      height: 622px;
    }
  }
  .bottom-wrap {
    padding: 0 55px 50px;
    .tip {
      font-size: 26px;
      color: #666666;
      text-align: center;
      margin-bottom: 10px;
      line-height: 44px;
    }
  }
}
</style>
